import React from "react";
import { Vector3, HemisphericLight, Mesh, ArcRotateCamera, SceneLoader, Axis } from "@babylonjs/core";
import { SkyMaterial } from '@babylonjs/materials';
import SceneComponent from "./SceneComponent"; // uses above component in same directory
// import SceneComponent from 'babylonjs-hook'; // if you install 'babylonjs-hook' NPM.
import '@babylonjs/loaders';
import * as Global from '../global.module.css';

let wings;
let parentModel;

let updated = false;
let camera;

const onSceneReady = (scene) => {

    // Arc camera
    camera = new ArcRotateCamera("Camera", 0, 0, 10, new Vector3(0, 5, 0), scene);

    camera.setPosition(new Vector3(0, 30, 40));

    const canvas = scene.getEngine().getRenderingCanvas();

    camera.alpha = 1.5757020918914018;
    camera.beta = 1.3105891488658221;
    camera.lowerRadiusLimit = camera.upperRadiusLimit = camera.radius;
    camera.upperAlphaLimit = camera.lowerAlphaLimit = camera.alpha;
    camera.upperBetaLimit = camera.lowerBetaLimit = camera.beta;
    camera.inputs.remove(camera.inputs.attached.mousewheel);

    // camera.lowerBetaLimit = 1.0;

    camera.attachControl(canvas, true);

    // This creates a light, aiming 0,1,0 - to the sky (non-mesh)
    let light = new HemisphericLight("light", new Vector3(0, 1, 0), scene);

    // Default intensity is 1. Let's dim the light a small amount
    light.intensity = 0.4;

    // Our built-in 'box' shape.
    //box = MeshBuilder.CreateBox("box", { size: 2 }, scene);

    // Move the box upward 1/2 its height
    //box.position.y = 5;

    SceneLoader.Append("/assets/models/", "scene.gltf", scene, function (scene) {
        wings = scene.meshes[scene.meshes.length - 1];
        parentModel = wings.parent;
    });

    //  Skybox
    // Material
    let skyMaterial = new SkyMaterial("skyMaterial", scene);
    skyMaterial.backFaceCulling = false;
    let skybox = Mesh.CreateBox("skyBox", 1000.0, scene);
    skyMaterial.inclination = 0.5;
    skyMaterial.turbidity = 7;
    skybox.material = skyMaterial;
};

/**
 * Will run on every frame render.  We are spinning the box on y-axis.
 */
const onRender = (scene) => {
    if (parentModel !== undefined) {
        var deltaTimeInMillis = scene.getEngine().getDeltaTime();
        const rpm = 0.5;
        parentModel.rotate(Axis.Y, (rpm / 60) * Math.PI * 2 * (deltaTimeInMillis / 1000));
    }

    if (wings !== undefined) {
        var deltaTimeInMillis = scene.getEngine().getDeltaTime();
        const rpm = 10;
        wings.rotate(Axis.Y, (rpm / 60) * Math.PI * 2 * (deltaTimeInMillis / 1000));
    }

    if (updated === false) {
        updated = true;
        let canvas = document.getElementById('my-canvas');
        let lWidth = document.documentElement.clientWidth;
        let lHeight = document.documentElement.clientHeight;

        let string = `width:${lWidth}px; height:${lHeight}px;`;

        canvas.setAttribute('width', lWidth);
        canvas.setAttribute('height', lHeight);

        canvas.parentElement.setAttribute('style', string);
    }
};

export default (props) => {
    return (
        <section id="hero" className={Global.pageSection3d}>
            <div className={Global.heroText}>
                <p>Victor Cortes</p>
                <p>Game and Web Developer</p>
                <br />
                <a href="#about-me" className={Global.fakeButton}>Know More</a>
            </div>
            <SceneComponent antialias onSceneReady={onSceneReady} onRender={onRender} id="my-canvas" />
        </section>
    );
};